module.exports = __webpack_public_path__ + "static/9-IMG-1878-0ac6d0919a4358356de01bdf0d1b4718.jpg";